import httpClient from '@xto10x/core/lib/httpClient';
import storage from '@xto10x/storage/lib/storage';
import config from 'utils/config';
import { StorageKey } from 'utils/constants';

const http = {
  get: (url, params) =>
    httpClient.get(`${config.feedbackApiUrl}${url}`, params, {
      AppSource: 'blitz',
      UserId: storage.getDataFromLocal(StorageKey.USER_INFO)?.user_reference_id,
      OrgId: storage.getDataFromLocal(StorageKey.ORG_INFO)?.org_reference_id,
      subdomain: storage.getDataFromLocal(StorageKey.ORG_INFO)?.sub_domain
    }),

  put: (url, data, params) =>
    httpClient.put(`${config.feedbackApiUrl}${url}`, data, params, {
      AppSource: 'blitz',
      UserId: storage.getDataFromLocal(StorageKey.USER_INFO)?.user_reference_id,
      OrgId: storage.getDataFromLocal(StorageKey.ORG_INFO)?.org_reference_id,
      subdomain: storage.getDataFromLocal(StorageKey.ORG_INFO)?.sub_domain
    }),

  patch: (url, data, params) =>
    httpClient.patch(`${config.feedbackApiUrl}${url}`, data, params, {
      AppSource: 'blitz',
      UserId: storage.getDataFromLocal(StorageKey.USER_INFO)?.user_reference_id,
      OrgId: storage.getDataFromLocal(StorageKey.ORG_INFO)?.org_reference_id,
      subdomain: storage.getDataFromLocal(StorageKey.ORG_INFO)?.sub_domain
    }),

  post: (url, data, params) =>
    httpClient.post(`${config.feedbackApiUrl}${url}`, data, params, {
      AppSource: 'blitz',
      UserId: storage.getDataFromLocal(StorageKey.USER_INFO)?.user_reference_id,
      OrgId: storage.getDataFromLocal(StorageKey.ORG_INFO)?.org_reference_id,
      subdomain: storage.getDataFromLocal(StorageKey.ORG_INFO)?.sub_domain
    }),

  delete: (url, data, params) =>
    httpClient.delete(`${config.feedbackApiUrl}${url}`, data, params, {
      AppSource: 'blitz',
      UserId: storage.getDataFromLocal(StorageKey.USER_INFO)?.user_reference_id,
      OrgId: storage.getDataFromLocal(StorageKey.ORG_INFO)?.org_reference_id,
      subdomain: storage.getDataFromLocal(StorageKey.ORG_INFO)?.sub_domain
    })
};

const feedbackApi = {
  getReviewsModuleSettings: () =>
    http.get('/core/api/v1/organization/settings'),
  getUserCompetencies: id =>
    http.get(`/core/api/v2/compentencies/feedback?user_id=${id}`),
  getUserPastReviews: id =>
    http.get(
      `/core/api/v2/authenticate/reviews?user=${id}&limit=-1&order_by=desc`
    ),
  getUserImportedReviews: id =>
    http.get(`/core/api/v2/reviews/review-import/${id}`),
  fetchUserPastFeedbacks: id => http.get(`/core/api/v2/feedbacks/for/${id}`)
};

export default feedbackApi;
